import { downloadSopPdf, type SopPdfInput } from './downloadSopPdf.ts';

/** Entry point used by the SOP detail UI. */
export async function runSopPdfDownload(input: SopPdfInput): Promise<void> {
  await downloadSopPdf(input);
}
